module.exports = __webpack_public_path__ + "img/Partners 4.7e9af01c.png";